import { makeStyles } from '@rbx/ui';

const useOpenAPIAppContainerStyles = makeStyles()(() => ({
  container: {
    gap: '16px',
    paddingBottom: '24px',
  },
  description: {
    padding: '8px 0',
  },
  operations: {
    gap: '12px',
  },
}));

export default useOpenAPIAppContainerStyles;
